import { inject } from 'vue';
import type { TimeTableGateway } from '@/widgets/Wizard/gateways/time-table';
import { timeTableContainer, tommyContainer } from '@/widgets/Wizard/modules/container';
import type { TommyGateway } from '@/widgets/Wizard/gateways/tommy';
import { storeToRefs } from 'pinia';
import { useMetadataStore } from '../stores/metadata';

export function useTimeTableGateway(): TimeTableGateway {
    const gateway = inject<TimeTableGateway>(timeTableContainer.gateway);

    if (!gateway) {
        throw new Error('Time table gateway could not be injected!');
    }

    return gateway;
}

export function useTommyGateway(): TommyGateway {
    const { activeAccount } = storeToRefs(useMetadataStore());

    if (!activeAccount.value) {
        throw new Error('Tommy gateway could not be injected! (no account configured)');
    }

    let gateway: TommyGateway | undefined = undefined;

    switch (activeAccount.value.tommy.version) {
        case 2:
            gateway = inject<TommyGateway>(tommyContainer.tommy2.gateway);
            break;

        case 3:
            gateway = inject<TommyGateway>(tommyContainer.tommy3.gateway);
            break;
    }

    if (!gateway) {
        throw new Error('Tommy gateway could not be injected! (no gateway configured)');
    }

    return gateway;
}
